import axios from 'axios';
import { Config } from 'config';
import { IPlan } from '../../types/Plan';
import { IPlanSku } from '../../types/PlanSku';
import { DeviceType } from '../../types/Device';

const PlansApiUrl = `${Config.url.PLAN_URL}/api/v1/Plan`;

const PlanSkuApiUrl = `${Config.url.PLAN_URL}/api/v1/PlanSku`;

const GetPlans = (onSuccess: (responseData: IPlan[]) => void, onFailure: () => void) => {
    axios.get(PlansApiUrl).then((response) => {
        const plans = response.data as IPlan[];
        const visiblePlans: IPlan[] = plans.filter((p) => p.isVisible);
        onSuccess(visiblePlans);
    }, onFailure);
};

const GetPlanSku = (
    planId: string,
    deviceType: DeviceType,
    lineNumber: number,
    onSuccess: (responseData: IPlanSku) => void,
    onFailure: () => void
) => {
    axios.get(`${PlanSkuApiUrl}/${planId}/${deviceType}/${lineNumber}`).then((response) => {
        onSuccess(response.data);
    }, onFailure);
};

export default { GetPlans, GetPlanSku };
